const languages = {
  en: 1,
  es: 3
}

export default languages
